/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.24"
        height="67.12"
        viewBox="0 0 82.24 67.12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M26.05 0a14.12 14.12 0 1 0 14.12 14.12A14.12 14.12 0 0 0 26.05 0Zm0 2.5a11.62 11.62 0 1 1-11.62 11.62A11.62 11.62 0 0 1 26.05 2.5ZM31.97 36.53A1.25 1.25 0 0 1 32.1 39H13.43A11 11 0 0 0 2.49 49.68v2.1A1.24 1.24 0 0 1 1.22 53 1.26 1.26 0 0 1 0 51.91V50a13.46 13.46 0 0 1 13.12-13.47ZM59.96 22.54a22.29 22.29 0 1 0 22.28 22.3 22.28 22.28 0 0 0-22.28-22.3Zm0 2.5a19.79 19.79 0 1 1-19.79 19.79 19.79 19.79 0 0 1 19.79-19.77Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M59.91 33.66a1.23 1.23 0 0 1 1.24 1.12v19.84a1.25 1.25 0 0 1-2.49.12V34.91a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M69.76 43.51a1.252 1.252 0 1 1 .13 2.5H50.06a1.26 1.26 0 0 1-1.22-1.28 1.24 1.24 0 0 1 1.09-1.21h19.83Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithPlusCircleIcon';

export default Icon;
